<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button default-href="/"></ion-back-button>
        </ion-buttons>
        <ion-title>Contacts</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <div class="cheader">
          <h1 id="cname">Kwazulu Natal</h1>
          <p id="csub">Provincial contacts</p>
          <div class="caction">
                <div class="cphone">
                    <img src="../assets/phone.png"/>
                    <p>phone</p>
                </div>
                <div class="cphone">
                    <img src="../assets/email.png"/>
                    <p>email</p>
                </div>
            </div>
      </div>
      <div class="cinfo">
          <div class="cphonesection">
              <p class="cinfo-label">phone</p>
              <p class="cinfo-value">(033) 395 2111</p>
              <div class="divider"></div>
          </div>
          <div class="cemailsection">
              <p class="cinfo-label">email</p>
              <p class="cinfo-value">Mandla.Duma@kznhealth.gov.za</p>
              <div class="divider"></div>
          </div>
      </div>
      
    </ion-content>
  </ion-page>
</template>

<script>
export default {
    name:'contacts'
}
</script>

<style scoped>
ion-toolbar {
  --ion-toolbar-background:#fbc414;
  --ion-text-color:white;
}
ion-back-button{
    --color:white;
}
ion-button{
    --background:#1b9346;
}
.cheader{
    border-bottom:1px solid #f3f3f5;
    background-color:#fbfaff;
    padding-bottom:66px;
    padding-right:11px;
    padding-left:11px;
    position:relative;
    padding-top:33px;
    cursor:default;
    width:100%;
}
#cname {
    vertical-align:middle;
    margin-bottom:10px;
    margin-top:44px;
    text-align:center;
    line-height:1em;
    font-size:2.2em;
    width:100%;
}
#csub{
    text-align:center;
    font-weight:300;
    font-size:1.1em;
    color:#808080;
}
.caction {
    justify-content: center;
    display: flex;
}
.cphone {
    border-radius:30px;
    margin-bottom:11px;
    margin-right:20px;
    margin-left:20px;
    margin-top:22px;
    cursor:pointer;
    height:40px;
    width:40px;
}
.cphone img{
    vertical-align:middle;
    text-align:center;
    line-height:60px;;
    font-size:30px;
    color:white;
    height:40px;
    width:40px;
}
.cphone p{
    text-align:center;
    font-size:0.8em;
    margin-top:10px;
    cursor:default;
    color:#1b9346;
}
.cinfo {
    background-color:white;
    cursor:default;
    padding:40px;
    width:100%;
}
.cinfo-label {
    display:inline;
    font-size:1em;
}
.cinfo-value {
    padding-bottom:22px;
    margin-bottom:11px;
    padding-top:11px;
    font-size:1.3em;
    cursor:pointer;
    color:#1c7ef8;
}
.divider {
    border: 1px solid #f3f3f5;
    margin-bottom:44px;
}
</style>